import React from 'react';
import { Switch, Tooltip } from '@material-ui/core';
import { BILLABLE_HELP } from '../constants';
import { BillableLabel } from './blocks';

/**
 * "Billable" switch in a new-order column's header. It only reports the change through `onChange`; nothing is
 * written until the split is submitted. Unlike `BillableToggle`, it never calls the server.
 *
 * @param {{ label: string, checked: boolean, onChange: (billable: boolean) => void, disabled?: boolean }} props
 *   `label` is the column's order number, for the accessible name. `disabled` locks it, for example while a split
 *   is submitting.
 */
export const BillableSwitch = ({ label, checked, onChange, disabled = false }) => (
    <Tooltip title={BILLABLE_HELP} placement="top" arrow>
        <BillableLabel>
            <Switch
                color="primary"
                size="small"
                checked={checked}
                disabled={disabled}
                onChange={(event) => onChange(event.target.checked)}
                inputProps={{ 'aria-label': `Billable: ${label}` }}
            />
            Billable
        </BillableLabel>
    </Tooltip>
);

export default BillableSwitch;
